import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AlertService } from './alert/alert.service';
import { AuthService } from './auth/auth.service';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { PageTitleService } from './services/page-title.service';
import { map, filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  private routerSub: Subscription;
  private routerTitleSub: Subscription;
  constructor(
    public authService: AuthService,
    public alertService: AlertService,
    private router: Router,
    private titleService: PageTitleService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {}
  ngOnInit() {
    let title = this.titleService.getTitle();
    this.routerTitleSub = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          const child = this.activatedRoute.firstChild;
          if (child?.snapshot.data['title']) {
            return child?.snapshot.data['title'];
          } else if (child?.firstChild?.snapshot.data['title']) {
            return child?.firstChild?.snapshot.data['title'];
          }
          return title;
        })
      )
      .subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
      });
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        this.dialog.closeAll();
      });
  }
  ngOnDestroy() {
    this.routerSub?.unsubscribe();
    this.routerTitleSub?.unsubscribe();
  }
}
